module.exports = __webpack_public_path__ + "static/media/secao-3-2-bg.de599319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-3-2-bg.jpg
// module id = 938
// module chunks = 7